import {computed} from "mobx";
import {EntityViewModel} from "../../../infrastructure/models/entity/entity.view-model";
import {Type} from "../../../infrastructure/type";
import {MemberDomainModel} from "./member-domain-model";
import {AthleteMetadataModel} from "../../common/athlete/athlete-metadata-model";
import {MemberLogoParams} from "./member-logo-params";
import {AthleteLinkModel} from "../../../containers/athlete-container/models/athlete-link-model";
import {SportViewModel} from "../../sports/models/sport-view-model";
import {ATHLETE} from "../../../core/app/consts";
import {FullAthleteIndividualStatViewModel} from "../../full-athlete/models/full-athlete-stats/full-athlete.individual-stat.view-model";

export class MemberViewModel extends EntityViewModel {
  domainModel: MemberDomainModel;

  get sport(): SportViewModel {
    return this.domainModel.sport && new SportViewModel(this.domainModel.sport);
  }

  get isNational(): Boolean {
    return this.domainModel.isNational;
  }

  get competitorId(): Boolean {
    return this.domainModel.competitorId;
  }

  get logoType(): Type {
    return MemberLogoParams;
  }

  get linkModel(): AthleteLinkModel {
    const enableAthleteLinkModel = this.athleteId > 0 && !ATHLETE.BLOCKED_SPORT_TYPES_ATHLETES.includes(this.sport?.id);
    const linkModel: AthleteLinkModel = enableAthleteLinkModel && new AthleteLinkModel(this.athleteId, this.sport?.nameForURL, this.nameForURL, this.isNational, null, null, null, this.isFollow);

    return linkModel;
  }

  @computed get athleteId() {
    return this.domainModel.athleteId;
  }

  @computed get jerseyNumber() {
    return this.hasJerseyNumber ? this.domainModel.jerseyNumber : '';
  }

  @computed get hasJerseyNumber() {
    return this.domainModel.jerseyNumber > 0;
  }

  get metadataType(): AthleteMetadataModel {
    return AthleteMetadataModel;
  }

  @computed get hasShotChart() {
    return this.domainModel.hasShotChart;
  }

  @computed get suspensionRisk(): Boolean {
    return this.domainModel.suspensionRisk;
  }

  @computed get suspensionStats(): Array<FullAthleteIndividualStatViewModel> {
    return this.domainModel.suspensionStats ? this.domainModel.suspensionStats.map((stats: FullAthleteIndividualStatViewModel) => new FullAthleteIndividualStatViewModel(stats)) : null;
  }

  @computed get suspensionDangerText(): Boolean {
    return `${this.domainModel.suspensionStats.first().value} - ${this.domainModel.suspensionStats.first().name}`
  }
}
